// Keeps the add-to-cart price label and the submitted quantity in sync with the selected offer
// (Buy 1 / Buy 2 / Buy 3 quantity breaks or the Glow Duo bundle).
class SRitualOffer extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', () => this.#sync(), { signal: this.#ac.signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const checked = this.querySelector('input[name="ritual"]:checked');
    const form = this.closest('form');
    if (!checked || !form) return;

    const quantityInput = this.querySelector('[data-ritual-quantity]');
    if (quantityInput) quantityInput.value = checked.dataset.quantity || '1';

    for (const target of form.querySelectorAll('[data-ritual-atc-price]')) {
      target.textContent = checked.dataset.price || '';
    }
  }
}

if (!customElements.get('s-ritual-offer')) customElements.define('s-ritual-offer', SRitualOffer);
